// Italian translation of ra-supabase-language-english, plus the keys Atomic
// overrides or adds in i18nProvider.ts (password reset, OAuth consent page).
export const italianRaSupabaseMessages = {
  "ra-supabase": {
    auth: {
      email: "Email",
      confirm_password: "Conferma password",
      sign_in_with: "Accedi con %{provider}",
      forgot_password: "Password dimenticata?",
      reset_password: "Reimposta password",
      password_reset:
        "Controlla la tua email: ti abbiamo inviato il messaggio per reimpostare la password.",
      missing_tokens: "Mancano i token di accesso e di aggiornamento",
      back_to_login: "Torna all'accesso",
    },
    reset_password: {
      forgot_password: "Password dimenticata?",
      forgot_password_details:
        "Inserisci la tua email per ricevere le istruzioni.",
    },
    set_password: {
      new_password: "Scegli la password",
    },
    validation: {
      password_mismatch: "Le password non coincidono",
    },
    oauth: {
      authorize: "Autorizza l'applicazione",
      authorize_details: "Questa applicazione vuole accedere al tuo account.",
      access_scope:
        "Potrà leggere e modificare i tuoi dati, con gli stessi permessi del tuo account.",
      approved: "Autorizzazione concessa",
      close_tab: "Ora puoi chiudere questa scheda.",
      no_request: "Nessuna richiesta di autorizzazione trovata",
    },
  },
};
